import React, {useState} from 'react';
import Cookies from 'universal-cookie';
import axios from 'axios';
import signinImage from '../assets/side-banner.png';

const cookies = new Cookies();

const initialState = {
    fullName: '',
    username: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    avatarURL: '',
}

const Auth = () => {
    const [isSignup, setIsSignup] = useState(true);
    const [form, setForm] = useState(initialState);
    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value}); //since form is an object, pass the values in an obj
    }
    const switchMode = () => {
        setIsSignup((prevIsSignup) => !prevIsSignup)
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        //console.log({form}); //this form will have values whatever we typed in the form. need to pass these to backend for further processing
        const { username, phoneNumber, avatarURL, password } = form;
       // const URL = 'http://localhost:5000/auth';
        const URL = 'https://freelancing-community.herokuapp.com/auth';
        
        const { data: { token, userId, hashedPassword, fullName } } = await axios.post(`${URL}/${isSignup ? 'signup' : 'login'}`, {
            username, password, fullName: form.fullName, phoneNumber, avatarURL,
        }) // extracting token, userId, hashedPassword from backend - created in server. need to store these in browser cookies
        
        /* const { data: { token, userId, hashedPassword, fullName } } -> Extracting data from backend.
          We're extracting fullName too from backend coz when user logs in - he doesn't have to type his fullName,
          It'll be fetched from the cookies we stored when he's signing up. So fullName here will just be an empty string.
          fullName: form.fullName -> We're passing the fullName whatever we entered in the form initially
          and not the ones from cookies
         */
        cookies.set('token', token);
        cookies.set('username', username);
        cookies.set('fullName', fullName);
        cookies.set('userId', userId);

        if(isSignup){
            cookies.set('phoneNumber', phoneNumber);
            cookies.set('avatarURL', avatarURL);
            cookies.set('hashedPassword', hashedPassword);
        }
        window.location.reload(); //after setting cookies we need to reload the browser
    }

  return (
    <div className="auth__form-container">
      <div className="auth__form-container_fields">
        <div className="auth__form-container_fields-content">
            <p>{isSignup ? 'Freelance Community Sign Up' : 'Freelance Community Sign In'}</p>
            <form onSubmit={handleSubmit}>
                {isSignup && ( /* this field will appear only if it's a signup page coz signup && condition applied here*/ 
                    <div className="auth__form-container_fields-content_input">
                        <label htmlFor='fullName'>Full Name</label>
                        <input 
                            name="fullName"
                            type="text"
                            placeholder="Full Name"
                            onChange={handleChange}
                            required
                            />
                    </div>
                )}
                <div className="auth__form-container_fields-content_input">
                        <label htmlFor='username'>Username</label> {/* && condition not applied here coz this field needs to appear in both signup and signin pages */}
                        <input 
                            name="username"
                            type="text"
                            placeholder="Username"
                            onChange={handleChange}
                            required
                            />
                    </div>
                    {isSignup && (
                            <div className="auth__form-container_fields-content_input">
                                <label htmlFor="phoneNumber">Phone Number</label>
                                <input 
                                    name="phoneNumber" 
                                    type="number"
                                    placeholder="Phone Number"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        )}
                        {isSignup && (
                            <div className="auth__form-container_fields-content_input">
                                <label htmlFor="avatarURL">Avatar URL</label>
                                <input 
                                    name="avatarURL" 
                                    type="text"
                                    placeholder="Avatar URL"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        )}
                        <div className="auth__form-container_fields-content_input">
                                <label htmlFor="password">Password</label>
                                <input 
                                    name="password" 
                                    type="password"
                                    placeholder="Password"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        {isSignup && (
                            <div className="auth__form-container_fields-content_input">
                                <label htmlFor="confirmPassword">Confirm Password</label>
                                <input 
                                    name="confirmPassword" 
                                    type="password"
                                    placeholder="Confirm Password"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            )}
                            <div className="auth__form-container_fields-content_button">
                            <button>{isSignup ? "Sign Up" : "Sign In"}</button>
                        </div>
                </form>
                <div className="auth__form-container_fields-account">
                        <p>
                            {isSignup
                             ? "Already have an account?" 
                             : "Don't have an account?"
                             }
                             <span onClick={switchMode}>
                             {isSignup ? ' Sign In' : ' Sign Up'}
                             </span>
                        </p>
                    </div>
        </div>
      </div>
      <div className="auth__form-container_image">
                <img src={signinImage} alt="sign in" />
            </div>
    </div>
  );
};

export default Auth;
